export default __webpack_public_path__ + "b7d457e15ccc5424529dcb5810e16740.png";